import type { SetStateAction } from 'react';
import type React from 'react';
import type { ExternalListing } from 'contexts/ExternalAuthContext';

export type BadgeItemType = 'queue' | 'showings' | 'tools';

export type StyledMenuProps = {
  selectedKey: string;
  openKeys?: string[];
  setOpenKeys?: React.Dispatch<SetStateAction<any[]>>;
  listings?: ExternalListing[];
  disableToolTip: boolean;
  renderBadgeItem?: (itemType: BadgeItemType, to: string) => React.ReactNode;
  getIconColor: (key: string | string[]) => null | 'primary';
};

export enum MLSStaffMenuOptions {
  users,
  brokerages,
  lockboxes,
  quickAssignment,
  modal,
}

export type MLSStaffMenuOptionsType = keyof typeof MLSStaffMenuOptions;

export const mlsStaffMenuOptionsMap: Record<MLSStaffMenuOptionsType, string> = {
  users: 'Users',
  brokerages: 'Brokerages',
  lockboxes: 'Lockboxes',
  quickAssignment: 'Quick Assignment',
  // Not used -- added to satisfy type
  modal: '',
};
